import { useDispatch } from "react-redux";
import { Modal, Button, Alert, FormInput } from "components/common";
import { processRequestUserAccount } from "redux/request/userAccountSlice";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";

const HoldToProcessForm = ({ open, setOpen, record }) => {
  const { register, handleSubmit, formState: { errors } } = useForm({});

  const dispatch = useDispatch();

  const closeModal = () => {
    setOpen(false);
  };

  const onSubmit = async (data) => {
    try {
      await dispatch(processRequestUserAccount({ recordId: record.id, data })).unwrap();
      closeModal();
    }
    catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={open}
      onHide={closeModal}
      title="Hold to process Request"
      backdropClick={false}
      footer={(
        <div className="tw-flex tw-justify-center tw-gap-2 tw-w-full">
          <Button type="submit" variant="primary" className="tw-px-4" form="hold-to-process-form">
            <FaCheckCircle className="tw-mr-2" /> Submit
          </Button>
          <Button variant="ghost" onClick={closeModal} className="tw-px-4">
            Cancel
          </Button>
        </div>
      )}
    >
      <form id="hold-to-process-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">
          This action will notify the submitter that the request is awaiting processing until further notice.
        </Alert>

        <FormInput
          label="Comment"
          type="textarea"
          rows={10}
          placeholder="Give some comments..."
          error={errors.comment_by_it?.message}
          {...register("comment_by_it", { required: "Comment is required" })}
        />
      </form>
    </Modal>
  );
};

HoldToProcessForm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired
};

export default HoldToProcessForm;
